const setSeminarSelected = (seminarID: number | string) => {
    const seminarTimestamp = (document.querySelector(`#${seminarID} .module--teaserlist-press--item-date`) as HTMLElement | null)?.dataset.timestamp
    if (!seminarTimestamp) {
        return
    }

    const seminarConferenceLink = (document.querySelector(`#${seminarID}`) as HTMLElement | null)?.dataset.conferencelink
    const seminarTitle = (document.querySelector(`#${seminarID} .module--teaserlist-press--item-title`) as HTMLElement | null)?.innerHTML.trim()
    const seminarDate = (document.querySelector(`#${seminarID} .module--teaserlist-press--item-date`) as HTMLElement | null)?.innerHTML.trim()

    if (!seminarConferenceLink || !seminarTitle || !seminarDate) {
        return
    }

    (document.querySelector('[id ^=addressForm_kundenclubVerkaufstraining][id $=conferenceLink]') as HTMLInputElement | null)!.value = seminarConferenceLink;
    (document.querySelector('[id ^=addressForm_kundenclubVerkaufstraining][id $=seminarTitle]') as HTMLInputElement | null)!.value = seminarTitle;
    (document.querySelector('[id ^=addressForm_kundenclubVerkaufstraining][id $=seminarTimestamp]') as HTMLInputElement | null)!.value = seminarTimestamp;
    (document.querySelector('[id ^=addressForm_kundenclubVerkaufstraining][id $=seminarDate]') as HTMLInputElement | null)!.value = seminarDate
}

document.addEventListener('DOMContentLoaded', () => {
    const seminarSelect = document.querySelector('[id^="addressForm_kundenclubVerkaufstraining"][id$="singleselect-2"]') as HTMLSelectElement | null
    if (seminarSelect) {
        const seminarItems: NodeListOf<HTMLElement> = document.querySelectorAll('.kundenclubSeminarList li.module--teaserlist-press--item') as NodeListOf<HTMLElement>
        seminarItems.forEach((seminarItem: HTMLElement) => {
            if (!(seminarItem.querySelector('.module--teaserlist-press--item-date') as HTMLElement | null)?.dataset.timestamp) {
                seminarItem.style.cursor = 'not-allowed'
            }
        })

        const selectableSeminars: NodeListOf<HTMLElement> = document.querySelectorAll('.kundenclubSeminarList li.module--teaserlist-press--item:not(.no-date)') as NodeListOf<HTMLElement>
        selectableSeminars.forEach((seminarItem: HTMLElement) => {
            const template = document.createElement('template')
            template.innerHTML = `<option data-sid="${seminarItem.id}" value="${(seminarItem.querySelector('.module--teaserlist-press--item-date') as HTMLElement).dataset.timestamp}">${(seminarItem.querySelector('.module--teaserlist-press--item-title') as HTMLElement).innerHTML.trim()} - ${(seminarItem.querySelector('.module--teaserlist-press--item-date') as HTMLElement).innerHTML.trim()}</option>`
            seminarSelect.appendChild(template.content.firstChild as HTMLOptionElement)
            seminarItem.addEventListener('click', () => {
                const seminarID = seminarItem.id
                const optionToSelect = seminarSelect.querySelector(`option[data-sid='${seminarID}']`) as HTMLOptionElement | null
                if (optionToSelect) {
                    optionToSelect.selected = true
                    seminarSelect.closest('form')?.parentElement?.scrollIntoView({ behavior: 'smooth' })
                    setSeminarSelected(seminarID)
                }
            })

        })

        seminarSelect.addEventListener('change', e => {
            const selectedOption = (e.target as HTMLSelectElement).selectedOptions[0]
            const seminarID = selectedOption.dataset.sid
            if (seminarID) {
                setSeminarSelected(seminarID)
            }
        })
    }

    let visibleElements = 5
    const seminarList = document.querySelector('.kundenclubSeminarList #teaserlistWrapper .module--teaserlist .module--teaserlist-press--container ul') as HTMLElement | null

    if (seminarList) {
        // Count items until the 5th non-separator item
        let count = 0
        const items = seminarList.querySelectorAll('li')
        for (let index = 0; index < items.length; index++) {
            if (items[index].classList.contains('module--teaserlist-press--item')) {
                count++
            }
            if (count === visibleElements) {
                visibleElements = index + 1
                break
            }
        }
        const separatorElements = seminarList.querySelectorAll(`.separator.module--teaserlist-press--item-title:nth-child(n + ${visibleElements + 1})`) as NodeListOf<HTMLElement>

        if (seminarList.querySelectorAll('li.module--teaserlist-press--item').length > visibleElements) {
            const initiallyHiddenItems: NodeListOf<HTMLElement> = seminarList?.querySelectorAll(`li.module--teaserlist-press--item:nth-child(n + ${visibleElements + 1})`) as NodeListOf<HTMLElement>
            initiallyHiddenItems.forEach((item: HTMLElement) => {
                item.style.display = 'none'
            })
            separatorElements.forEach((item: HTMLElement) => {
                item.style.display = 'none'
            })

            const template = document.createElement('template')
            template.innerHTML = `
            <div class="buttonContainer">
                <div class="buttonWrapper">
                    <div class="showButton">Mehr anzeigen</div>
                </div>
            </div>
        `.trim()
            seminarList.insertAdjacentElement('afterend', template.content.firstChild as HTMLElement)
            seminarList.parentElement?.querySelector('.showButton')?.addEventListener('click', e => {
                if ((e.target as HTMLElement).textContent === 'Mehr anzeigen') {
                    (e.target as HTMLElement).textContent = 'Weniger anzeigen'
                } else {
                    (e.target as HTMLElement).textContent = 'Mehr anzeigen'
                }
                (e.target as HTMLElement).classList.toggle('showLessDeg')
                initiallyHiddenItems.forEach((item: HTMLElement) => {
                    if (item.style.display === 'none') {
                        item.style.display = ''
                    } else {
                        item.style.display = 'none'
                    }
                })
                separatorElements.forEach((item: HTMLElement) => {
                    if (item.style.display === 'none') {
                        item.style.display = ''
                    } else {
                        item.style.display = 'none'
                    }
                })
            })
        }
    }

    const seminarRegistrationForm = document.querySelector('[id^="addressForm_kundenclubVerkaufstraining"]') as HTMLFormElement | null;
    if (seminarRegistrationForm) {
        const genderField = seminarRegistrationForm.querySelector('select[name$="[singleselect-1]"]') as HTMLSelectElement | null;
        const firstNameField = seminarRegistrationForm.querySelector('input[name$="[text-2]"]') as HTMLInputElement | null;
        const lastNameField = seminarRegistrationForm.querySelector('input[name$="[text-3]"]') as HTMLInputElement | null;
        const companyField = seminarRegistrationForm.querySelector('input[name$="[text-1]"]') as HTMLInputElement | null;
        const emailField = seminarRegistrationForm.querySelector('input[name$="[email-1]"]') as HTMLInputElement | null;
        fetch('/api/form-prefill', {
            method: 'GET',
            credentials: 'same-origin',
        }).then(response => {
            if (response.ok) {
                return response.json().then(data => {
                    if (genderField) {
                        if (data.gender === 0) {
                            // Check for option with value male, Mr, Mr., Herr
                            const maleOption = Array.from(genderField.options).find(option => {
                                return option.value.toLowerCase() === 'male' || option.value.toLowerCase() === 'mr' || option.value.toLowerCase() === 'mr.' || option.value.toLowerCase() === 'herr';
                            })
                            if (maleOption) {
                                genderField.value = maleOption.value;
                            }
                        } else if (data.gender === 1) {
                            // Check for option with value female, Ms, Ms., Mrs, Mrs., Frau
                            const femaleOption = Array.from(genderField.options).find(option => {
                                return option.value.toLowerCase() === 'female' || option.value.toLowerCase() === 'ms' || option.value.toLowerCase() === 'ms.' || option.value.toLowerCase() === 'mrs' || option.value.toLowerCase() === 'mrs.' || option.value.toLowerCase() === 'frau';
                            })
                            if (femaleOption) {
                                genderField.value = femaleOption.value;
                            }
                        }
                    }

                    if (firstNameField) {
                        firstNameField.value = data.firstName || '';
                    }

                    if (lastNameField) {
                        lastNameField.value = data.lastName || '';
                    }

                    if (companyField) {
                        companyField.value = data.company || '';
                    }

                    if (emailField) {
                        emailField.value = data.email || '';
                    }
                });
            }
        })
    }
})
